import { Box, Button, CircularProgress, Container, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TypeFrigorficos, TypePlantas } from '../home/interace/frigorifico.interface';
import { CamaraType, TypeCamaras } from './interface/camara.interface';
import { useGetValorCamarasByFrioIdQuery } from "../../api/frioApi";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { handleMutationError } from "../../api/handleMutationError";
import { CamaraAmoniacoComponent } from "../../components/Camara_Amoniaco";
import { SalaMaquinasComponent } from "../../components/Sala_Maquinas";
import { MedidasElectricasComponent } from "../../components/Medidas_Electricas";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';


export const CamarasPage: React.FC = () => {

  const navigate = useNavigate();
  const frioData = useLocation();


  //Si los parametros son null o no existem vuelve a home
  React.useEffect(() => {
    if (!frioData.state) {
      navigate('/');
    }
  }, [frioData, navigate]);



  const planta: TypePlantas | undefined = frioData.state?.planta;
  const frio: TypeFrigorficos | undefined = frioData.state?.frio;


  const {
    data,  
    isLoading,
    isError, 
    error
  } = useGetValorCamarasByFrioIdQuery({plantaId: planta?.id ?? "", frioId: frio?.id ?? ""}, {
      skip: !planta?.id || !frio?.id, // 👈 Importante: no ejecuta la query si no hay id
      //refetchOnMountOrArgChange: true, //revalida la informacion cuando se monta el componente, pero la revalidacion la hace en background 
      //refetchOnFocus: true, //revalida la informacion cuando se pone el focus
      //refetchOnReconnect: true, //revalida la informacion cuando se vuelve a conectar el servidor
      pollingInterval: 60000, //Hace un polling cada 60 seg para revalidar la informacion con el servidor
   });




     // 🔹 Restaurar posición cuando vuelve la vista
  React.useEffect(() => {
    const savedScroll = sessionStorage.getItem("scrollPositionCamaras");
    if (savedScroll) {
      window.scrollTo(0, parseInt(savedScroll, 10));
      sessionStorage.removeItem("scrollPositionCamaras");
    }
  }, []);

  // 🔹 Guardar posición antes de navegar
  const handleNavigateToGraficos = (propsPlanta: any, propsFrio: any, propsCamara: any) => {
    sessionStorage.setItem("scrollPositionCamaras", window.scrollY.toString());
    navigate("/graficos", { state: { propsPlanta, propsFrio, propsCamara } });
  };


  function renderizarTipoCamara(camara: TypeCamaras) {
    //console.log("Camara", camara);
    switch (camara.tipo) {
      case CamaraType.CAMARA_AMONIACO:
        return <CamaraAmoniacoComponent
                      key = {camara.id}
                      propsCamara={camara}
                      onVerGrafico={() => handleNavigateToGraficos(planta, frio, camara)}
                />;
      case CamaraType.SALA_MAQUINAS:
        return <SalaMaquinasComponent
                      key = {camara.id}
                      propsCamara={camara}
                      onVerGrafico={() => handleNavigateToGraficos(planta, frio, camara)}
                />;   
      case CamaraType.MEDIDAS_ELECTRICAS:
        return <MedidasElectricasComponent
                      key = {camara.id}
                      propsCamara={camara}
                      onVerGrafico={() => handleNavigateToGraficos(planta, frio, camara)}
                />;                          
      default:
        return <p>No se ha elegido ninguna opción</p>;
    }
  }

    // 🔹 Si no hay datos aún, no renderiza nada
  if (!frioData.state) {
    return <></>;
  }

    return (
    <Container 
      maxWidth={false} 
      sx={{
        px: 2, // padding horizontal: 2*8px = 16px
      }}
    > 
    {/*<Container maxWidth="xl">*/}
        <Stack sx={{my: 2}} spacing={2} direction="row">
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/")}
            startIcon={<KeyboardDoubleArrowLeftIcon />} 
          >
            PLANTAS
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/frigorificos", { state: planta })}
            startIcon={<NavigateBeforeIcon />} 
          >
            SECTORES
          </Button>
        </Stack>
        {isError && <p>Falla Conexion con el servidor: {error? handleMutationError(error) : 'Falla no reconocida'}</p>}
        {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
        ):(            
          <>
            {/* Título de la Lista */}
            <Typography
              textAlign="center"
              sx={{
                marginTop: 2,
                marginBottom: 2,
                fontSize: {
                  xs: "1.2rem",  // móviles
                  sm: "1.5rem",  // tablets
                  md: "1.8rem",  // notebooks
                  lg: "2rem",    // monitores grandes
                  xl: "2.2rem",  // pantallas muy grandes
                },
                fontWeight: "bold",
              }}
            >              
              {"Planta: " + planta?.name_front}
            </Typography>
            <Typography
              textAlign="center"
              sx={{
                marginTop: 1,
                marginBottom: 2,
                fontSize: {
                  xs: "1rem",
                  sm: "1.3rem",
                  md: "1.6rem",
                  lg: "1.8rem",
                  xl: "2rem",
                },
              }}
            >              
              {"Sector: " + frio?.name_front}
            </Typography>
            {/* Renderizar Filas */}
            <Grid container spacing={2}>
              {data.data.camaras?.length > 0 ? (
                data.data.camaras!.map((camara: TypeCamaras) => (
                  //Segun el tipo de camara que sea, se llama al componete para renderizar
                    <Grid
                      key={camara.id}
                      item
                      xs={12}     // En pantallas pequeñas (celulares): ocupa todo el ancho (1 cámara por fila)
                      sm={6}      // En pantallas medianas (tablets): 2 cámaras por fila
                      md={4}      // En pantallas grandes (PCs): 3 cámaras por fila
                      lg={3}      // En pantallas muy grandes: 4 cámaras por fila
                    >                    
                      {renderizarTipoCamara(camara)}
                   </Grid>
                ))
              ) : (
                <Typography 
                  variant="body1" 
                  textAlign="center" 
                  sx={{ marginTop: 4 }}
                >
                  No hay sensores para mostrar.
                </Typography>
              )}
            </Grid>
          </>
          )}
      </Container>
    );
}
